import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const QUERY_CLIENT = gql`
  query($clientId: ID!) {
    client(id: $clientId) {
      id
      division {
        name
      }
      payrollcycle {
        id
        name
      }
    }
  }
`
export const ClientPayrollCycle = ({ clientId }) => (
  <Query query={QUERY_CLIENT} variables={{ clientId }}>
    {({ loading, error, data }) => {
      if (loading) {
        return null  // TODO show spinner or stencil
      }

      if (error) {
        return null  // TODO show icon..?
      }

      if (data === null) {
        return 'Client not found'
      }

      return data.client.payrollcycle
        ? data.client.payrollcycle.name
        : '-'
    }}
  </Query>
)



// WEBPACK FOOTER //
// ./src/components/client-payroll-cycle/index.js